export default "__VITE_ASSET__940bf10e__"